import { Button, CircularProgress, Dialog, DialogContent } from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as React from "react";

import icConfirm from "../assets/ic-confirm.svg";

export default function MdConfirmAddDocs({ state, dispatch }) {
  const { mdRequestAdditionalDocs } = state;
  const classes = makeStyle();

  return (
    <Dialog
      open={!!mdRequestAdditionalDocs?.openConfirm}
      keepMounted
      className={classes.dialog}
    >
      <DialogContent style={{ padding: "20px 40px", textAlign: "center" }}>
        <img src={icConfirm} width={85} alt="ic-confirm" />
        <div className="text">Vui lòng kiểm tra lại chứng từ trước khi gửi yêu cầu bổ sung</div>
        {mdRequestAdditionalDocs?.loading ? (
          <div>
            <CircularProgress size={20} sx={{ my: 1, color: "#FB7801" }} />
            <div style={{fontSize: 13}}>Đang gửi yêu cầu bổ sung...</div>
          </div>
        ) : (
          <>
            
            <div className="text">Bạn chắc chắn muốn gửi yêu cầu bổ sung?</div>
            <div className="action">
              <Button
                className="cancel"
                onClick={() =>
                  dispatch({ type: "openConfirmOriginalDocs", open: false })
                }
              >
                Thoát
              </Button>
              <Button
                onClick={() => dispatch("onSubmitAddDocs")}
                className="submit"
              >
                Đồng ý
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

const makeStyle = makeStyles(() => ({
  dialog: {
    "& .MuiPaper-root.MuiPaper-elevation": {
      maxWidth: "450px",
      borderRadius: "12px",
    },

    "& .text": {
      margin: "12px 0",
      fontWeight: 600,
    },

    "& .action": {
      width: "100%",
      marginTop: 30,
      display: "flex",
      justifyContent: "space-between",
    },

    "& .cancel": {
      width: "45%",
      border: "1px solid #F0F2F5",
      borderRadius: "5px",
      background: "#F0F2F5",
      color: "#343A40",
    },

    "& .submit": {
      width: "45%",
      color: "white",
      background: "#284078",
      border: "1px solid #EBEDFF",
      borderRadius: "5px",
    },
  },
}));
